module.exports = __webpack_public_path__ + "img/logo_uni_trunk.ad578d4c.png";